import React from 'react'
import _ from 'lodash'

import InputText from '../../views/widgets/InputText'
import { fetchTags } from '../../../modules/portal-remote/portalService'
import { toast } from 'react-toastify'

class InputTextTagSuggestion extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tagName: '',
      filterTags: [],
      isShowPanel: false,
    }

    this.requestTags = _.debounce(this.requestTags, 500)
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.value, prevProps.value)) {
      this.setState({ tagName: this.props.value })
    }
  }

  handleInputTextChange = async e => {
    const {
      target: { name, value },
    } = e
    this.props.onChange(e)

    this.setState({
      [name]: value,
    })
    try {
      if (!_.isEmpty(value)) await this.requestTags(value)
    } catch (error) {
      toast.error('fetchTag error:' + error.message || '')
    }
  }

  handleTagSelect = tagName => {
    this.setState({ tagName, isShowPanel: false }, () => {
      this.props.onChange({ target: { name: 'tagName', value: tagName } })
    })
  }

  requestTags = async tagName => {
    const filterTags = await fetchTags(tagName)

    this.setState({
      filterTags,
      isShowPanel: !_.isEmpty(filterTags),
    })
  }

  render() {
    return (
      <div>
        <InputText
          {...this.props}
          name={`tagName`}
          onChange={this.handleInputTextChange}
          value={this.state.tagName}
        />
        {this.state.isShowPanel && (
          <nav
            className="panel"
            style={{
              position: 'absolute',
              zIndex: 10000,
              width: 200,
              background: 'white',
            }}
          >
            {_.map(this.state.filterTags, tagName => (
              <a
                className="panel-block"
                key={tagName}
                onClick={() => this.handleTagSelect(tagName)}
              >
                {tagName}
              </a>
            ))}
          </nav>
        )}

        {/* <a
        key={listing._id}
        className={classNames('panel-block', { 'is-active': isChecked })}
        onClick={() => this.handleListingToggle(listing, townRef)}
      >
        <span
          className="panel-icon"
          key={isChecked ? 'far fa-check-square' : 'far fa-square'}
        >
          <i
            className={isChecked ? 'far fa-check-square' : 'far fa-square'}
            aria-hidden="true"
          />
        </span>
        {listing.title.th}
      </a> */}
      </div>
    )
  }
}

export default InputTextTagSuggestion



// WEBPACK FOOTER //
// ./src/components/templates/general-info/InputTextTagSuggestion.js